<template>
    <div class="entity-table hg-table">
        <vue-good-table mode="remote"
                        @on-page-change="onPageChange"
                        @on-sort-change="onSortChange"
                        @on-column-filter="onColumnFilter"
                        @on-per-page-change="onPerPageChange"
                        :totalRows="entities.total"
                        :isLoading.sync="isLoading"
                        :pagination-options="{
                            enabled: true
                        }"
                        max-height="75vh"
                        :fixed-header="true"
                        :rows="entities.entries"
                        :row-style-class="rowStyleClassFn"
                        :columns="columns"
                        v-if="!!entities">
            <template slot="column-filter" slot-scope="props">
                <span v-if="props.column.filterOptions && !props.column.filterOptions.filterDropdownItems">
                    <input type="text" @keyup.enter="onColumnFilter(props.column.field, $event.target.value)" class="hg-input"/>
                </span>
                <span v-else-if="props.column.filterOptions && Array.isArray(props.column.filterOptions.filterDropdownItems)">
                    <select type="text" 
                            @change="onColumnFilter(props.column.field, $event.target.value)" 
                            class="hg-select">
                        <option :value="''"></option>
                        <option v-for="a in props.column.filterOptions.filterDropdownItems" :key="a.value" :value="a.value">
                            {{a.text}}
                        </option>
                    </select>
                </span>
            </template>
            <template slot="table-row" slot-scope="props">
                <slot name="table-row" v-bind="props"></slot>
            </template>
            <template slot="loadingContent">
                <font-awesome-icon :icon="['fas','futbol']" spin size="6x"/>
            </template>
            <div slot="emptystate">
                <span v-i18n="'NO_DATA'"/>
            </div>
            <template slot="pagination-bottom" slot-scope="props">
                <custom-pagination
                    :style="{
                        display: hidePagination?'none':'flex'
                    }"
                    :totalRecords="entities.total"
                    :totalPages="entities.max_page"
                    :pageIndex="entities.page_index"
                    :pageSize="entities.page_size"
                    :pageChanged="props.pageChanged"
                    :perPageChanged="props.perPageChanged">
                </custom-pagination>
            </template>
        </vue-good-table>
    </div>
</template>
<script>
import customPagination from "./custom_pagination";
import { VueGoodTable } from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css'
export default {
    components: {
        // contacts,
        customPagination,
        VueGoodTable
    },
    props: {
        entities: {
            type: Object,
            default: function(){
                return {
                    entries: []
                }
            }
        },
        columns: {
            type: Array,
            default: function(){
                return [];
            }
        },
        loadItems: {
            type: Function
        },
        hidePagination: {
            type: Boolean,
            default: false
        },
        rowStyleClassFn: {
            type: Function
        }
    },
    mounted(){
        this.columns.sort(function(a,b){
            if(a.hidden) return 1;
            if(b.hidden) return -1;
            return 0;
        })
        this.loadItems(this.serverParams);
    },
    data(){
        return {
            isLoading: false,
            serverParams: {
                columnFilters: {},
                sort: { /*field: '',type: ''*/ },
                page: 0, 
                perPage: 20
            }
        }
    },
    methods: {
        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
        },
        onPageChange(params) {
            this.updateParams({page: params.currentPage});
            var p = this.loadItems(this.serverParams);
            if(p instanceof Promise){
                var self = this;
                this.isLoading = true;
                p.finally(function(){
                    self.isLoading = false;
                })
            }
        },
        onPerPageChange(params) {
            this.updateParams({perPage: params.currentPerPage});
            var p = this.loadItems(this.serverParams);
            if(p instanceof Promise){
                var self = this;
                this.isLoading = true;
                p.finally(function(){
                    self.isLoading = false;
                })
            }
        },
        onSortChange(params) {
            this.updateParams({sort: params});
            var p = this.loadItems(this.serverParams);
            if(p instanceof Promise){
                var self = this;
                this.isLoading = true;
                p.finally(function(){
                    self.isLoading = false;
                })
            }
        },
        onColumnFilter(key, value) {
            if(key!= undefined && value != ""){
                var params = {
                    page: 0,
                    columnFilters: { 
                        [key]: new RegExp("/?/*" + value + "/?/*", "gi") 
                    } 
                } 
                this.updateParams(params);
            }else if(value == ""){
                delete this.serverParams.columnFilters[key]
            }else{
                return;
            }
            var p = this.loadItems(this.serverParams);
            if(p instanceof Promise){
                var self = this;
                this.isLoading = true;
                p.finally(function(){
                    self.isLoading = false;
                })
            }
        },
    }
}
</script>
<style>
/* .entity-table .vgt-wrap{
   position: relative; 
}
.entity-table .vgt-loading.vgt-center-align{
    position: absolute;
    width: 100%;
    height: 100%;
    padding: 20px;
    color:var(--hg-red);
    text-align:center;
}
.entity-table .vgt-inner-wrap{
    transition: opacity 100ms ease-in-out;
    opacity:1;
}
.entity-table .vgt-loading.vgt-center-align + .vgt-inner-wrap{
    opacity: 0.1;
} */

.entity-table table{
    background: transparent!important;
}
.entity-table .vgt-inner-wrap{
    box-shadow:none;
}



.entity-table .vgt-fixed-header {
    position: relative !important;
}
.entity-table .vgt-fixed-header th:last-child {
    /* Offset for the scrollbar, you may have to adjust this */
    width: calc(100% + 17px) !important;
}
.entity-table .vgt-responsive .vgt-table  thead {
    visibility: collapse !important;
}




.entity-table .vgt-table.bordered{
    border:0 solid transparent;
}
.entity-table .vgt-table.bordered td, 
.entity-table .vgt-table.bordered th{
    border-left-width:0;
    border-right-width:0;
    background:transparent;
    padding:.75em .75em .75em .75em;
    color:#000;
}
.entity-table .vgt-table.bordered th{
    border-top-width:0;
    font-weight:bold;
    color:#FFFFFF;
    white-space:nowrap;
    overflow:hidden;
    text-overflow: ellipsis;
}

.entity-table .vgt-table.bordered thead{
    background:rgba(0,0,0,.8);
    border-radius:5px 5px 0 0;
}
.entity-table .vgt-table.bordered tbody{
    background:rgba(0,0,0,.05);
}
.entity-table .vgt-table.bordered tbody tr:nth-child(odd){
    background:rgba(0,0,0,.05);
}
.entity-table .vgt-table th.sortable:not(.sorting-desc) button:before{
    border-top-color:transparent;
}
.entity-table .vgt-table th.sortable:not(.sorting-asc) button:after{
    border-bottom-color:transparent;
}
.entity-table .vgt-table th.sortable.sorting-desc button:before{
    border-top-color:var(--hg-red);
}
.entity-table .vgt-table th.sortable.sorting-asc button:after{
    border-bottom-color:var(--hg-red);
}
.entity-table .table-pager{
    background:rgba(0,0,0,.01);
}
/* .entity-table th span:not(:empty)+button{
    border-width:0;
    background:red;

} */
</style>